module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Future Edge Group","short_name":"Future Edge","start_url":"/","background_color":"#0f172a","theme_color":"#0f172a","display":"standalone","icon":"/home/runner/work/ftredge_ui/ftredge_ui/src/assets/icons/logomark_feg.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"5576ec2bbdd0fe56b12e09a019b9aa6a"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
